import { MultiCashoutStatus } from "../../../../pages/multiCashouts/constants";
import { IPaginatedResponse } from "../../models";
import { ExecuteWithdrawBody } from "../withdraws/models";

export enum WithdrawType {
  MULTI_CASH_OUT = "MULTI_CASH_OUT",
}

export enum MultiCashoutCountStatus {
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  STILL_PENDING = "STILL_PENDING",
}

export interface MultiCashoutItem {
  userId: string;
  userName: string;
  numberOfPendingTransfers: number;
  amount: number;
}
export interface MultiCashoutPaymentItem {
  amount: number;
  beneficiaryId: number;
  beneficiaryName: string;
  createdAt: string;
  id: number;
  status: MultiCashoutStatus;
  numberOfTransactions: number;
}

export interface SortInfo {
  empty: boolean;
  sorted: boolean;
  unsorted: boolean;
}

export interface Pageable {
  sort: SortInfo;
  offset: number;
  pageNumber: number;
  pageSize: number;
  paged: boolean;
  unpaged: boolean;
}

export type IMultiCashoutResponseData = IPaginatedResponse<MultiCashoutItem[]>;

export type IMultiCashoutPaymentResponseData = IPaginatedResponse<
  MultiCashoutPaymentItem[]
>;

export interface IMultiCashoutFilterParams {
  page?: number;
  size?: number;
  domainId?: string;
  beneficiaryId?: string;
}

export interface IMultiCashoutPaymentsParams extends IMultiCashoutFilterParams {
  statuses?: string;
}

export interface IMultiCashoutContractItem {
  shortId: string;
  amount: number;
  title: string;
}

export interface IMultiCashoutDetailsResponseData {
  sellerAndBrokerContracts: IPaginatedResponse<IMultiCashoutContractItem[]>;
  buyerContracts: IPaginatedResponse<IMultiCashoutContractItem[]>;
  totalSellerAmount: number;
  totalSellerContractsCount: number;
}

export interface ICreateMultiCashoutRequest {
  beneficiaryId: number;
  amount?: string;
  beneficiaryName: string;
  withdrawalExecute?: ExecuteWithdrawBody;
  withdrawType?: WithdrawType;
}

export interface ICreateMultiCashoutResponseData {
  beneficiaryId: string;
  withdrawalId: string;
  status: string;
  amount: number;
}

export interface IMultiCashoutCountByTypeResponseData {
  counts: Record<MultiCashoutCountStatus, number>;
}
